import React from 'react';
import { symptoms } from '../../data/overview';
export function Approach() {
  return <section className="bg-ivory" data-id="element-34" data-mp="24vim8vj6toz1">
      <div className="mx-auto grid max-w-site gap-12 px-5 py-20 md:px-8 lg:grid-cols-12 lg:gap-16 lg:py-28" data-id="element-35" data-mp="24uqnjbuanb4j">
        <div className="lg:col-span-7" data-id="element-36" data-mp="29vo97yeiinas">
          <p className="font-mono text-[12px] uppercase tracking-[0.16em] text-copperDeep" data-id="element-37" data-mp="2ety222crlbt8">The Problem & the Approach</p>
          <h2 className="mt-4 font-display text-[32px] font-bold leading-[1.1] text-ink lg:text-[42px]" data-id="element-38" data-mp="1h78ttargy2yx">Know where to begin—and what to check next.</h2>
          <div className="mt-6 space-y-5 text-[17px] leading-[1.7] text-inkSoft lg:text-[18px]" data-id="element-39" data-mp="1m3g2hbb91skk">
            <p data-id="element-40" data-mp="1r2kavzqcnm9u">
              Similar symptoms can have different causes. A hard start may trace back to fuel supply, air ingress, an electrical concern, or a
              recent service — and the order you check things in matters.
            </p>
            <p data-id="element-41" data-mp="13e9d55fya2ps">
              The collection helps organize preliminary checks, diagnostic evidence, testing sequences, and decisions, so each step follows from
              what you have already found instead of moving between possible causes without a clear sequence.
            </p>
            <p className="font-semibold text-ink" data-id="element-42" data-mp="3iszzzr7xaj7z">You bring the experience. The collection keeps the investigation organized.</p>
          </div>
        </div>
        <div className="lg:col-span-5 lg:pt-12" data-id="element-43" data-mp="3dscbpdb2wghg">
          <p className="font-mono text-[12px] uppercase tracking-[0.14em] text-inkSoft" data-id="element-44" data-mp="39t3j4brryonh">Common starting points</p>
          <ul className="mt-4 border-t border-ink/80" data-id="element-45" data-mp="34sp6egf8aqj4">
            {symptoms.map(s => <li key={s} className="flex items-center gap-4 border-b border-rule py-3.5 text-[17px] text-ink" data-id="element-46" data-mp="2zvp2ab1xvxun">
                <span className="h-px w-4 shrink-0 bg-copperDeep" aria-hidden="true" data-id="element-47" data-mp="2uwuk9bbsqdbl" />
                {s}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}